var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"section-header"},[_c('h1',[_vm._v(_vm._s(_vm.$t("ui.affiliate_list")))])]),_c('div',{staticClass:"section-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[(_vm.isOperator)?[_c('affiliateListOperator')]:[_c('affiliateListAdmin')]],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }